// const React = require("react")

// const { Provider } = require("react-redux")

// const store = require("./src/state/store")

// exports.wrapRootElement = ({ element }) => {
//   return <Provider store={store}>{element}</Provider>
// }

// export { default as wrapRootElement } from "./src/state/ReduxWrapper"
import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider
